export const DEFAULT_SELECTION_PLACEHOLDER = {
    selectionId: '0',
    isAdding: false,
    isAdded: false,
    isUpdating: false,
    isRemoving: false,
    isSuspended: false,
    isProcessing: false,
};
export const SELECTION_BUTTON_MIN_WIDTH = 60;
